<template>
  <router-link :to="go_to()" class="invoice link">
    <tr>
      <td class="text-left w14per" :data-label="translate('invoice.client_name')">
        {{ invoice.client_name }}
      </td>
      <td class="text-left w14per" :data-label="translate('invoice.invoice_name')">
        {{ invoice.invoice_name }}
      </td>
      <td :data-label="translate('invoice.date')" class="w5per">
        {{ invoice.date }}
      </td>
      <td :data-label="translate('invoice.invoice_number')" class="w6per">
        {{ invoice.invoice_number }}
      </td>
      <td :data-label="translate('invoice.type')" class="w3per">
        {{ invoice.type_title }}
      </td>
      <td :data-label="translate('invoice.device_count')" class="w6per">
        {{ invoice.device_count }}
      </td>
      <td :data-label="translate('invoice.sum')" class="sum w7per">
        {{ (invoice.sum / 100).toFixed(2) }}
      </td>
      <td :data-label="translate('invoice.validation_status')" class="w8per">
        <span class="badge" :style="'background-color: ' + new_status(invoice.validation_status).color">
          {{ new_status(invoice.validation_status).title }}
        </span>
      </td>
      <td :data-label="translate('invoice.date_act')" class="w7per">
        {{ invoice.date_act }}
      </td>
      <td :data-label="translate('invoice.issue_date')" class="w7per">
        {{ invoice.date_create }}
      </td>
      <td :data-label="translate('invoice.edo')" class="w3per" :title="get_edo(invoice.client_edo_id)">
        {{ get_edo(invoice.client_edo_id).slice(0, 1) }}
      </td>
      <td :data-label="translate('invoice.is_correction')" class="w3per">
        {{ invoice.is_correction ? translate('yes') : '' }}
      </td>
      <td :data-label="translate('invoice.payment_status')" v-if="$store.getters.getPermissions.permissionGod  === true" class="w10per">
        <span v-if="get_payment_status(invoice.payment_status) === null"></span>
        <span v-else class="badge" :style="'background-color: ' + get_payment_status(invoice.payment_status).color">
          {{ get_payment_status(invoice.payment_status).descr }}
        </span>
      </td>
      <td :data-label="translate('invoice.date_payment')" v-if="$store.getters.getPermissions.permissionGod  === true" class="w7per">
        {{ invoice.date_payment }}
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'InvoiceListItem',
  components: {
  },
  props: ["invoice"],
  data () {
    return {
    }
  },
  methods: {
    get_edo(edo_id){
      const edo_system = this.$store.getters.getClientEdoSystems.find((edo) => {
        if (edo_id === edo.id) return edo
      })
      return edo_system ? edo_system.title : ""
    },
    get_payment_status(status_id){
      let state = this.$store.getters.getClientInvoicesInfo.payment_statuses.find((status) => {
        if (status_id === status.id){
          return status
        }
      })
       return state ? state : null
    },
    go_to() {
      return { path: '/invoice/' + this.invoice.id }
    },
    new_status(status_id){
      let status = this.$store.getters.getClientInvoicesInfo.validation_statuses.find((stat) => {
        if (stat.id === status_id) return stat
      })
      return status ? {...status, title: this.translate("invoice.validation_statuses." + status.title) } : {title: "Error", color: "red"}
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    &.text-left{
      text-align: left;
    }
    overflow: hidden;
    vertical-align: middle;
    font-size: 12px;
    &.sum{
      text-align: right;
      padding-right: 20px;
    }
  }
}
</style>
